import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { useGetProfileQuery } from 'services/authApi';
import { getAuthenticatedEntryPath } from 'utils/adminAccess';

/**
 * Redirects authenticated users to the role-appropriate home route.
 */
const AuthenticatedEntryRedirect = () => {
  const { token, user } = useSelector((state) => state.auth);
  const { data: profile, isLoading } = useGetProfileQuery(undefined, {
    skip: !token,
  });
  const currentUser = user || profile;

  if (token && !currentUser && isLoading) {
    return <Loading cover="page" />;
  }

  const target = currentUser
    ? getAuthenticatedEntryPath(currentUser)
    : AUTHENTICATED_ENTRY;

  return <Navigate replace to={target} />;
};

export default AuthenticatedEntryRedirect;
